<template>
  <div id="edit-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="openEditExchangeModal" persistent max-width="530px">
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">Update Exchange Rate</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeEditExchangeRateModal(), $validator.reset()" class="close"
                  >&times;</v-btn
                >
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert type="success" :value="successAlert">
                Exchange rate updated successfully
              </v-alert>
              <v-alert type="success" :value="errorAlert">
                Please update anything
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex sm7 md7>
                    <v-text-field
                      style="width: 70%"
                      label="USD price*"
                      v-model="editExchangeRateData.usd_price"
                      :error-messages="errors.collect('USD price')"
                      v-validate="'required|integer'"
                      data-vv-name="USD price"
                    ></v-text-field>
                  </v-flex>

                  <v-flex sm7 md7>
                    <v-text-field
                      style="width: 70%"
                      label="TL price*"
                      v-model="editExchangeRateData.tl_price"
                      :error-messages="errors.collect('TL price')"
                      v-validate="'required|decimal:2'"
                      data-vv-name="TL price"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeEditExchangeRateModal(), $validator.reset()"
                outline
                color="normal"
                >Cancel</v-btn
              >
              <v-btn type="submit" style="height:auto; margin-right: 4%" outline color="success"
                >Save</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'openEditExchangeModal',
    'closeEditExchangeRateModal',
    'successAlert',
    'errorAlert',
    'editExchangeRateData',
    'editExchangeRate'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editExchangeRate()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/exchangeRate/editExchangeRate.vue